import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@mui/material';
import CookieBanner from '../CookieBanner';
import theme from '../theme';
import InsideHome from './InsideHome';
import InsideArticle from './InsideArticle';
import InsideStoryForm from './InsideStoryForm';
import './inside.css';

export default function InsideApp() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className="inside-root">
        <BrowserRouter>
          <Routes>
            <Route path="/inside" element={<InsideHome />} />
            <Route path="/inside/raccontaci" element={<InsideStoryForm />} />
            <Route path="/inside/:slug" element={<InsideArticle />} />
            <Route path="*" element={<Navigate to="/inside" replace />} />
          </Routes>
        </BrowserRouter>
        <CookieBanner />
      </div>
    </ThemeProvider>
  );
}
